import type { LabelPrintFormat, LabelPrintMarginSettings } from "./types.js";

/** Fusionne format catalogue + réglages utilisateur (rouleau, facteur). */
export function applyMarginSettingsToFormat(
  format: LabelPrintFormat,
  margins?: LabelPrintMarginSettings,
): LabelPrintFormat {
  if (!margins) return format;
  return {
    ...format,
    rollWidthMm: margins.rollWidthMm ?? format.rollWidthMm,
    rollOffsetFactor: margins.rollOffsetFactor ?? format.rollOffsetFactor,
  };
}

/** Décalage horizontal total (mm) depuis le bord gauche du rouleau. */
export function resolveHorizontalOffsetMm(
  _format: LabelPrintFormat,
  contentMarginMm: number,
  margins: LabelPrintMarginSettings | undefined,
  rollCenterOffsetMm: number,
): number {
  if (margins?.marginLeftMm != null) {
    return margins.marginLeftMm;
  }
  return contentMarginMm + rollCenterOffsetMm;
}

export function resolveBrandTopMm(margins?: LabelPrintMarginSettings, fallback = 7): number {
  return margins?.marginTopMm ?? fallback;
}

export function resolveBrandZoneMm(margins?: LabelPrintMarginSettings, fallback = 15): number {
  return margins?.brandZoneMm ?? fallback;
}

export function resolveContentMarginMm(margins?: LabelPrintMarginSettings, fallback = 1): number {
  return margins?.contentMarginMm ?? fallback;
}

/** Applique un décalage vertical global aux positions Y. */
export function shiftLayoutYMm<T extends { yMm: number }>(
  items: T[],
  barcodeYMm: number,
  extraTopMm: number,
): { lines: T[]; barcodeYMm: number } {
  if (!extraTopMm) {
    return { lines: items, barcodeYMm };
  }
  return {
    lines: items.map((line) => ({ ...line, yMm: line.yMm + extraTopMm })),
    barcodeYMm: barcodeYMm + extraTopMm,
  };
}
